import { render } from "./MobileAppComponent.vue?vue&type=template&id=1cfdd0d3&scoped=true"
import script from "./MobileAppComponent.vue?vue&type=script&lang=js"
export * from "./MobileAppComponent.vue?vue&type=script&lang=js"

import "./MobileAppComponent.vue?vue&type=style&index=0&id=1cfdd0d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfdd0d3"]])

export default __exports__